import { format_money } from '~/components/Money';
import FormGroup from '~/components/form/FormGroup';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import BreAerialFields from '~/tenants/bre/performable/aerial/BreAerialFields';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TenantPackageAddOnRepeat } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import dedent from 'dedent';
import { ReactElement } from 'react';
import BreCopyrightDisclosure from '~/tenants/bre/performable/BreCopyrightDisclosure';
import { PersonaType } from '~/tenants/common/TenantPersona';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import { FormHorizontal } from '~/components/form/layout';
import BreAerialData from '~/tenants/bre/performable/aerial/BreAerialData';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import { bre_is_aerial_photo, BreAerialType } from '~/tenants/bre/performable/aerial/BreAerialConfig';
import { bre_is_copyright } from '~/tenants/bre/performable/common';
import { Row } from '~/components/layout/Sections';

export default function BreAerialForm({ context, persona }: TenantPerformableFormProps<BreOrderContext>): ReactElement {
  const type = useZodFormFieldSingleValue<BreAerialType>('type');

  return (
    <FormGroup>
      <BreAerialFields context={context} />

      {persona === PersonaType.OFFICE && (
        <>
          <FormHorizontal label="Self Edited Video">
            <ZodFieldCheckbox name="self_edited" />
          </FormHorizontal>

          {bre_is_aerial_photo(type) && (
            <FormHorizontal label="Photo Editing Credits">
              <ZodFieldInput name="editing_credits" type="number" />
            </FormHorizontal>
          )}
        </>
      )}

      <TenantPerformableAddOns persona={persona}>
        <TenantPackageAddOnRepeat
          name="poi"
          title="Points of Interest"
          description={dedent`
            Add-On nearby points of interest. First 7 for only
            ${format_money(BreAerialData.poi)}, then ${format_money(BreAerialData.poi_each)}/each.
          `}
          image="tenant/bre/aerial/poi.jpg"
          persona={persona}
        >
          <Row>
            <ZodFieldInput name="name" placeholder="Name" />
            <ZodFieldInput name="location" placeholder="Location" />
          </Row>
        </TenantPackageAddOnRepeat>
      </TenantPerformableAddOns>

      {bre_is_copyright(context.metadata.type) && <BreCopyrightDisclosure context={context} />}
    </FormGroup>
  );
}
